import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Footer } from "../components/Footer.js";
import { Slide_title } from "../components/slide-title.js";
import { Account_head } from "../components/account_head.js";
import { add_Saddress, update_Saddress, shipping_address_detail } from "../service/api.js";
import ErrorSnackbar from '../components/ErrorSnackbar.js';
import SuccessSnackbar from '../components/SuccessSnackbar.js';
import Head_CateHead from '../components/Head_CateHead.js';
import { AddressForm, validateAddress } from '../components/AddressForm.js';

export const Acc_Saddress = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [ExceptionError, setExceptionError] = useState([]);
    const [successMessages, setSuccessMessages] = useState([]);
    const [submitbutton, setsubmitbutton] = useState(true);
    const [validationErrors, setValidationErrors] = useState({});

    // Address fields using the AddressForm prefix convention
    const [addressValues, setAddressValues] = useState({
        shipping_Company: '',
        shipping_Building: '',
        shipping_StreetAddress: '',
        shipping_Suburb: '',
        shipping_Postcode: '',
        shipping_State: '',
    });

    // ── Error / Success helpers ───────────────────────────────────────────
    function handleExceptionError(res) {
        setExceptionError(prev => [...prev, { id: Date.now(), message: res }]);
    }

    function handleExceptionSuccessMessages(res) {
        setSuccessMessages(prev => [
            ...prev,
            { id: Date.now(), message: res.data.Message },
        ]);
    }

    function clearErrors(id) {
        setExceptionError(prev => prev.filter(msg => msg.id !== id));
    }

    function clearSuccess(id) {
        setSuccessMessages(prev => prev.filter(msg => msg.id !== id));
    }

    // ── Load existing address when editing ────────────────────────────────
    const data_get = async () => {
        try {
            const res = await shipping_address_detail(id);
            const d = res.data.Data;
            setAddressValues({
                shipping_Company: d.SCompany || '',
                shipping_Building: d.SBuilding || '',
                shipping_StreetAddress: d.SStreetAddress || d.SAddress1 || '',
                shipping_Suburb: d.SSuburb || d.SCity || '',
                shipping_Postcode: d.SPostcode || d.SZipcode || '',
                shipping_State: d.SState || '',
            });
        } catch (error) {
            console.error("Error fetching shipping address:", error);
        }
    };

    useEffect(() => {
        if (!localStorage.getItem('token')) {
            navigate("/signin");
        }
        if (id) {
            data_get();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // ── AddressForm onChange handler ──────────────────────────────────────
    const handleAddressChange = (fieldName, value) => {
        setAddressValues(prev => ({ ...prev, [fieldName]: value }));
        setValidationErrors(prev => ({ ...prev, [fieldName]: undefined }));
    };

    // ── Submit ────────────────────────────────────────────────────────────
    const handleSubmit = async (event) => {
        event.preventDefault();

        const errors = validateAddress(addressValues, "shipping");
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            return;
        }
        setValidationErrors({});
        setsubmitbutton(false);

        const payload = {
            SCompany: addressValues.shipping_Company,
            SBuilding: addressValues.shipping_Building,
            SStreetAddress: addressValues.shipping_StreetAddress,
            SSuburb: addressValues.shipping_Suburb,
            SPostcode: addressValues.shipping_Postcode,
            SState: addressValues.shipping_State,
        };

        if (id) {
            const res = await update_Saddress(payload, id);
            if (res.status === 200) {
                handleExceptionSuccessMessages(res);
                navigate("/saved_address");
            } else {
                setsubmitbutton(true);
                handleExceptionError(res.response?.data?.ErrorMessage || "Update failed");
            }
        } else {
            const res = await add_Saddress(payload);
            if (res.status === 200) {
                handleExceptionSuccessMessages(res);
                navigate("/saved_address");
            } else {
                setsubmitbutton(true);
                handleExceptionError(res.response?.data?.ErrorMessage || "Save failed");
            }
        }
    };

    return (
        <div>
            <ErrorSnackbar errorMessages={ExceptionError} onClearErrors={clearErrors} />
            <SuccessSnackbar successMessages={successMessages} onclearSuccess={clearSuccess} />
            <Head_CateHead />
            <Account_head />
            <div className="sign_in_wrapper container account">
                <div className="container sign_container">
                    <Slide_title title={id ? "Edit Shipping Address" : "Add Shipping Address"} className="add_address_page_title" />
                    <div className="sign_up_wrapper">
                        <form onSubmit={handleSubmit} noValidate>
                            <AddressForm
                                prefix="shipping"
                                values={addressValues}
                                errors={validationErrors}
                                onChange={handleAddressChange}
                            />
                            <br />
                            <div className="order_box_delete">
                                {submitbutton ? (
                                    <button style={{ backgroundColor: '#01AEF0' }} type="submit">
                                        {id ? "Update" : "Add"}
                                    </button>
                                ) : (
                                    <button style={{ backgroundColor: '#01AEF0' }} type="button" disabled>
                                        Saving…
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};
